import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../../events'
import * as DA from '../../../../typeModules/events'
import DisclosureStep from './disclosure-step'
import IdentificationStep from './identification-step'
import VehicleStep from './vehicle-step'

type Props = {
  uniqueLink?: string
  error?: string
  doSubmit?: (uniqueLink: string, backgroundInfo: object) => Promise<any>
  vehicleTypes?: any
  trackBackgroundCheckSteps: (data: DA.TrackBackgroundCheck) => Promise<any>
}

const defaultVehicleState = {
  vehicleType: -1,
  licenseNumber: '',
  licenseState: '',
  insuranceCheck: false,
}

const defaultIdentificationState = {
  ssn: '',
  birthday: '',
}
export const BackgroundCheckSteps: React.FC<Props> = props => {
  const [vehicleData, setVehicleData] = React.useState(defaultVehicleState)

  const [identificationData, setIdentificationData] = React.useState(
    defaultIdentificationState
  )

  const handleSubmit = async data => {
    const { doSubmit, uniqueLink } = props
    try {
      const res = await doSubmit(uniqueLink, {
        ...vehicleData,
        ...identificationData,
        ...data,
      })
      return res
    } catch (e) {
      // Handle potential API Errors Here
      // Resets state back to default
      setVehicleData(defaultVehicleState)
      setIdentificationData(defaultIdentificationState)
      throw e
    }
  }

  const { vehicleTypes } = props

  const { vehicleType, licenseNumber, licenseState } = vehicleData
  const { birthday, ssn } = identificationData

  if (vehicleType < 0 || vehicleTypes[vehicleType].needs_license_info) {
    if (licenseNumber === '' || licenseState === '') {
      return <VehicleStep {...props} onSubmit={setVehicleData} />
    }
  }

  if (birthday === '' || ssn === '') {
    return <IdentificationStep {...props} onSubmit={setIdentificationData} />
  }

  return <DisclosureStep {...props} onSubmit={handleSubmit} />
}

const mapDispatchToProps = {
  trackBackgroundCheckSteps: events.trackBackgroundCheckSteps,
}

export default connect(null, mapDispatchToProps)(BackgroundCheckSteps)
